import { Button, Typography } from '@oscar/theme';
import React, { useState } from 'react';
import AddEditPopup from 'views/pages/setting-comp/user-management/components/AddEditPopup';
import PopupService from 'views/pages/setting-comp/service-provider/components/AddEditPopup';

import DeletePopup from './DeletePopup';
import DeletePopupService from './DeletePopupService';

function EditDeleteButtonsTable(props: any) {
  const { record, actionProps, isService } = props;
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  return (
    <>
      <Button type="primary" onClick={() => setShowEditPopup(true)}>
        Edit
      </Button>
      &nbsp;&nbsp;
      <Button onClick={() => setShowDeletePopup(true)}>Delete</Button>
      {showEditPopup &&
        (isService ? (
          <PopupService
            title="Edit Service Provider"
            isVisible={showEditPopup}
            labelConfirm="Edit"
            handleCancel={() => setShowEditPopup(false)}
            typePopup="edit"
            record={record}
            actionTable={actionProps}
          />
        ) : (
          <AddEditPopup
            title="Edit User"
            isVisible={showEditPopup}
            labelConfirm="Save"
            handleCancel={() => setShowEditPopup(false)}
            typePopup="edit"
            record={record}
            actionTable={actionProps}
          />
        ))}
      {showDeletePopup &&
        (isService ? (
          <DeletePopupService
            isVisible={showDeletePopup}
            handleCancel={() => setShowDeletePopup(false)}
            record={record}
            actionTable={actionProps}
          />
        ) : (
          <DeletePopup
            isVisible={showDeletePopup}
            handleCancel={() => setShowDeletePopup(false)}
            record={record}
            actionTable={actionProps}
          />
        ))}
    </>
  );
}

export default EditDeleteButtonsTable;
